import type { INewbuildingHouse } from '../../../../common/repositories/newbuilding-estimate/entities/newbuilding/NewbuildingHouse';
import { INewbuildingSectionItem } from '../../../types/formFields';

export const newbuildingSectionsListMapper = (sections: INewbuildingHouse[]): INewbuildingSectionItem[] => {
  return sections.map(({ id, name }) => ({
    label: name,
    value: id,
  }));
};
